import { useQuery } from '@tanstack/react-query';

import { ICON_URL_STALE_TIME } from '../../../app/constants';
import { getV1RequestsToJoinOptions } from '../../../api/generated/pap/@tanstack/react-query.gen';

/**
 * Query hooks for the Requests to Join the current Business Partner reviews
 * (Users → Requests, and the Overview's own-request status). See
 * `../../Settings/IdentityProviders/identityProviders.queries.ts` for the
 * pattern.
 */

/**
 * Pending Requests to Join the current Business Partner. Resolves to the
 * `items` array. Icon URLs in the response are presigned and expire, hence
 * the stale time.
 */
export const useRequests = (isUserAdmin: boolean = true) =>
  useQuery({
    ...getV1RequestsToJoinOptions(),
    select: (data) => data.items,
    enabled: isUserAdmin,
    staleTime: ICON_URL_STALE_TIME,
    refetchOnMount: true,
  });
